exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#custom-modal-footer{display:-ms-flexbox;display:flex;-ms-flex-pack:justify !important;justify-content:space-between !important}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}\n", ""]);

